<template>
  <v-container>
    <v-card-title class="text--center"> </v-card-title>
    <v-card>
      <v-card-title>
        Gestion des projets (Iskane)
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          @keyup.enter="filterKey"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :loading="loading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        loading-text="Veuillez patienter quelques instants "
        :search="search"
        @page-count="pageCount = $event"
        :options.sync="options"
        :server-items-length="totalDocuments"
        :headers="headers"
        :items="dataValues"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <!-- OnCreate Dialog -->

            <!-- ###### -->
            <v-dialog v-model="dialogs" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-sheet elevation="12" class="pa-12">
                <v-form
                  class="input--fields__wrapper"
                  ref="create"
                  lazy-validation
                  v-on:submit.prevent="onCreate"
                >
                  <v-virtual-scroll height="100" item-height="20">
                    <v-text-field
                      :rules="[rules.required]"
                      label="Intitulé du projet"
                      v-model="IntituleDuProjet"
                    ></v-text-field>

                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Province ou Préfecture /Commune ou arrondissement "
                        v-model="ProvinceCommune"
                      ></v-text-field>

                      <v-text-field
                        :rules="[rules.required]"
                        label="Programme"
                        v-model="Programme"
                      ></v-text-field>
                    </div>

                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Consistance"
                        v-model="Consistance"
                      ></v-text-field>

                      <v-text-field
                        :rules="[rules.required]"
                        label="Budget du projet"
                        v-model="BudgetDuProject"
                      ></v-text-field>
                    </div>

                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Maître d'ouvrage"
                        v-model="MaitreDouvrage"
                      ></v-text-field>
                      <v-text-field
                        :rules="[rules.required]"
                        label="Maître d'ouvrage délégué"
                        v-model="MaitreDouvrageDelegue"
                      ></v-text-field>
                    </div>

                    <v-file-input
                      :rules="[rules.required]"
                      id="fUploadCreate"
                      accept="image/*"
                      v-model="files"
                      multiple
                      placeholder="Upload"
                      label="Pièces jointes"
                      prepend-icon=""
                    >
                      <template v-slot:selection="{ text, item, selected }">
                        <v-chip
                          :rules="[rules.required]"
                          :input-value="selected"
                          close
                          @click:close="remove(item)"
                          small
                          label
                          color="primary"
                        >
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-virtual-scroll>
                </v-form>
              </v-sheet>
              <v-btn color="primary" @click="onCreate" tile>Créer</v-btn>
              <v-overlay :value="overlay">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.callStatus="{ item }">
          <v-chip :color="getColor(item.callStatus)" dark>
            {{ item.callStatus }}</v-chip
          >
        </template>
        <template v-slot:item.callOfferFile="{ item }">
          <v-btn
            @click="fifthPopUpDialog(item)"
            class="text-capitalize"
            color="primary"
            rounded
          >
            Ouvrir
          </v-btn>
        </template>
        <!-- Starts HERE -->

        <template v-slot:item.dataValues="{ item }">
          <v-icon medium class="ml-2" @click="firstPopUpDialog(item)">
            mdi-arrow-up
          </v-icon>
        </template>

        <template v-slot:item.projectData="{ item }">
          <v-icon medium class="ml-2" @click="secondPopUpDialog(item)">
            mdi-arrow-up
          </v-icon>
        </template>

        <template v-slot:item.Calendar="{ item }">
          <v-icon medium class="ml-2" @click="thirdPopUpDialog(item)">
            mdi-arrow-up
          </v-icon>
        </template>

        <template v-slot:item.ProjectRealisation="{ item }">
          <v-icon medium class="ml-2" @click="fourthPopUpDialog(item)">
            mdi-arrow-up
          </v-icon>
        </template>

        <!-- Extras HERE -->

        <template v-slot:item.delete="{ item }">
          <v-icon medium class="ml-5" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>

      <div class="class text-center pt-2">
        <v-pagination
          circle
          :total-visible="7"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="firstDialog" width="700" content-class="round">
      <v-sheet elevation="12" class="pa-12">
        <v-form
          class="input--fields__wrapper"
          ref="update"
          lazy-validation
          v-on:submit.prevent="onUpdate"
        >
          <v-virtual-scroll height="100" item-height="20">
            <v-text-field
              :rules="[rules.required]"
              label="Intitulé du projet"
              v-model="editedItem.IntituleDuProjet"
            ></v-text-field>

            <div class="input--fields__container">
              <v-text-field
                :rules="[rules.required]"
                label="Province ou Préfecture /Commune ou arrondissement "
                v-model="editedItem.ProvinceCommune"
              ></v-text-field>

              <v-text-field
                :rules="[rules.required]"
                label="Programme"
                v-model="editedItem.Programme"
              ></v-text-field>
            </div>

            <div class="input--fields__container">
              <v-text-field
                :rules="[rules.required]"
                label="Consistance"
                v-model="editedItem.Consistance"
              ></v-text-field>

              <v-text-field
                :rules="[rules.required]"
                label="Budget du projet"
                v-model="editedItem.BudgetDuProject"
              ></v-text-field>
            </div>

            <div class="input--fields__container">
              <v-text-field
                :rules="[rules.required]"
                label="Maître d'ouvrage"
                v-model="editedItem.MaitreDouvrage"
              ></v-text-field>
              <v-text-field
                :rules="[rules.required]"
                label="Maître d'ouvrage délégué"
                v-model="editedItem.MaitreDouvrageDelegue"
              ></v-text-field>
            </div>

            <v-row>
              <v-col
                v-for="n in editedItem.illustrations"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-img :src="n.src" aspect-ratio="1" class="grey lighten-2">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>

                  <div>
                    <v-btn text x-small class="pa-9 ml-10 mt-10">
                      <v-icon
                        color="white"
                        right
                        large
                        @click="deleteImageItem(n.id)"
                      >
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-col>
            </v-row>
            <v-file-input
              id="fUpload"
              accept="image/*"
              v-model="files"
              multiple
              placeholder="Upload"
              label="Pièces jointess"
              prepend-icon=""
            >
              <template v-slot:selection="{ text, item, selected }">
                <v-chip
                  :input-value="selected"
                  close
                  @click:close="remove(item)"
                  small
                  label
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-virtual-scroll>
          <v-overlay :value="overlayModify">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-form>
      </v-sheet>

      <v-btn color="primary" @click="onUpdate" tile>Modifier</v-btn>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  components: {},

  methods: {
    resetCreate() {
      this.$refs.create.reset();
    },

    checkRendering() {
      this.$store.state.sdrawer.toRender = true;
    },
    firstPopUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.editedItem._id = item._id;
      //
      this.firstDialog = true;
    },
    secondPopUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.editedItem._id = item._id;
      this.secondDialog = true;
    },
    thirdPopUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // this.editedItem._id = item._id;
      this.thirdDialog = true;
    },
    fourthPopUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.fourthDialog = true;
    },

    fifthPopUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.fifthDialog = true;
    },

    url(item) {
      window.open(`${item.callOfferFile.fileLocation}`);
    },
    ApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store
        .dispatch("projets/getProjects", {
          page: this.page,
          category: this.category,
        })
        .then((resp) => {
          this.loading = false;

          this.dataValues = resp.data.allProjects;
          this.totalDocuments = resp.data.totalNumber;
          this.itemsPerPage = resp.data.limit;
        });
    },
    FilterApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store
        .dispatch("projets/searchProject", {
          page: page,
          searchData: this.search,
          category: this.category,
        })
        .then((resp) => {
          console.log("the category", this.category);
          this.loading = false;

          this.dataValues = resp.data.allProjects;
          this.totalDocuments = resp.data.totalNumber;
        });
    },

    filterKey(event) {
      if (event.keyCode === 13) {
        this.FilterSort();
      }
    },

    extension_checker(tag) {
      const file = document.querySelector(tag);

      if (file !== null) {
        for (let index = 0; index < file.files.length; index++) {
          if (
            /\.(gif|jpg|png|bmp|jpeg)$/i.test(file.files[index].name) === false
          ) {
            //change the alert with a function that throws a snackbar or smtng
            alert("only images extensions are allowed");
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("projets/deleteProject", { _id: item._id })
          .then((resp) => {
            console.log("deleted");
            this.ApiCall();
          })
          .catch((error) => {});
    },
    deleteImageItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("projets/deleteProjectImage", {
            _id: this.editedItem._id,
            imageId: item,
          })
          .then((resp) => {
            this.firstDialog = false;
            this.overlayModify = false;
            this.ApiCall();
          })
          .catch((error) => {});
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.dataValues[this.editedIndex], this.editedItem);
      } else {
        this.dataValues.push(this.editedItem);
      }
      this.close();
    },

    onUpdate() {
      if (this.$refs.update.validate()) {
        if (this.extension_checker("#fUploadNew")) {
          let formData = new FormData();

          if (this.files !== null) {
            for (let file of this.files) {
              formData.append("files", file, file.name);
            }
          }

          formData.append("_id", this.editedItem._id);
          formData.append("IntituleDuProjet", this.editedItem.IntituleDuProjet);
          formData.append("ProvinceCommune", this.editedItem.ProvinceCommune);
          formData.append("Programme", this.editedItem.Programme);
          formData.append("Consistance", this.editedItem.Consistance);
          formData.append("BudgetDuProject", this.editedItem.BudgetDuProject);
          formData.append("MaitreDouvrage", this.editedItem.MaitreDouvrage);
          formData.append(
            "MaitreDouvrageDelegue",
            this.editedItem.MaitreDouvrageDelegue
          );
          formData.append("category", this.editedItem.category);

          // // // initial values for other inputs
          this.overlayModify = true;

          axios({
            url: "/api/3VLKE82QP27YT6DO423D/updateProject",
            method: "POST",
            data: formData,

            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((response) => {
              this.firstDialog = false;
              this.overlayModify = false;
              this.ApiCall();
              this.files = null;
            })
            .catch((error) => {});
        }
      }
    },

    onCreate() {
      if (this.$refs.create.validate()) {
        if (this.extension_checker("#fUploadCreate")) {
          let formData = new FormData();

          if (this.files !== null) {
            for (let file of this.files) {
              formData.append("files", file, file.name);
            }
          }

          formData.append("IntituleDuProjet", this.IntituleDuProjet);
          formData.append("ProvinceCommune", this.ProvinceCommune);
          formData.append("Programme", this.Programme);
          formData.append("Consistance", this.Consistance);
          formData.append("BudgetDuProject", this.BudgetDuProject);
          formData.append("MaitreDouvrage", this.MaitreDouvrage);
          formData.append("MaitreDouvrageDelegue", this.MaitreDouvrageDelegue);
          formData.append("category", this.category);

          // // // initial values for other inputs

          this.overlay = true;

          axios({
            url: "/api/3VLKE82QP27YT6DO423D/createProject",
            method: "POST",
            data: formData,

            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((response) => {
              this.ApiCall();
              this.resetCreate();
              this.overlay = false;

              this.dialogs = false;
            })
            .catch((error) => {});
        }
      }
    },

    FilterSort() {
      if (this.search !== null) {
        this.FilterApiCall();
      } else {
        return false;
      }
    },
  },
  computed: {
    test() {
      return this.$store.state.appels.obj;
    },
  },

  mounted() {
    this.loading = false;
    this.ApiCall();
    this.checkRendering();
  },

  watch: {
    options: {
      deep: true,
    },
  },

  data: () => ({
    fifthDialog: false,
    overlay: false,
    category: "Iskane",

    search: "",

    rules: {
      required: (value) => !!value || "Ce champ est obligatoire.",
      min: (v) =>
        v.length >= 8 || "Le champ doit contenir 8 caractères minimum",
      emailRules: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Veuillez entrer une adresse électronique valide",
    },

    loading: true,

    options: {},
    totalDocuments: 0,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    editedIndex: -1,
    firstDialog: false,
    secondDialog: false,
    thirdDialog: false,
    fourthDialog: false,
    overlayModify: false,

    defaultItem: {
      _id: "",
      IntituleDuProjet: "",
      ProvinceCommune: "",
      Programme: "",
      Consistance: "",
      BudgetDuProject: "",
      MaitreDouvrage: "",
      MaitreDouvrageDelegue: "",
      category: "Iskane",
      illustrations: [
        {
          id: "",
          src: "",
          thumbnail: "",
          alt: "",
        },
      ],
    },

    editedItem: {
      _id: "",
      IntituleDuProjet: "",
      ProvinceCommune: "",
      Programme: "",
      Consistance: "",
      BudgetDuProject: "",
      MaitreDouvrage: "",
      MaitreDouvrageDelegue: "",
      category: "Iskane",
      illustrations: [
        {
          id: "",
          src: "",
          thumbnail: "",
          alt: "",
        },
      ],
    },

    // Regular create values

    IntituleDuProjet: "",
    ProvinceCommune: "",
    Programme: "",
    Consistance: "",
    BudgetDuProject: "",
    MaitreDouvrage: "",
    MaitreDouvrageDelegue: "",
    category: "Iskane",

    headers: [
      { text: "Intitulé du projet", value: "IntituleDuProjet" },

      { text: "Détails", value: "dataValues" },

      { text: "Supprimer", value: "delete", show: true },
    ],
    dataValues: [],

    flex: [4, 6, 3],
    show: false,

    items: ["Attribué", "En cours", "Infructueux", "Annulé", "Publié"],

    // Details update

    files: null,
  }),
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap");

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.class {
  background-color: white;
}

.v-chip {
  width: 100px;
  justify-content: center;
}

/* Dialog Styling */

.round {
  border-radius: 30px;
  overflow-y: hidden;
}

@media only screen and (device-width: 1920px) and (device-height: 1080px) {
  .v-card {
    margin-left: 26px !important;
    width: 91%;
  }
}
</style>
